import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const GetSounBoxDevicePayloadUsingImei=async(imei)=>{
    const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_PAYLOAD_USING_IMEI}${imei}`)
    return response;
}

export const PushPaymentToDevice=async(deviceId,command, opts, id,organizationId)=>{

    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.PUSH_PAYMENT_TO_DEVICE,{
        "type": "cmd",
        "value": "action",
        "timestamp":Date.now().toString(),
        "id": id,
        "cmd": command,
        "imei": deviceId,
        ...(opts && { "opts": [opts] }),
        "organizationId":organizationId,
    }
)
    return response;
}
export const SaveTestResult=async(payload)=>{

    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.SAVE_TEST_RESULT,payload)
    return response;
}

export const CreateDevice=async(deviceId,organizationId,authId,lotNo)=>{

    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.CREATE_DEVICE_IN_INVENTORY,{
            "device_id": deviceId,
            "authenticationId"   : authId,
            "organizationId": organizationId,
            "lot_number":lotNo
        
        })
    return response;
}

export const AddDeviceToMerchant=async(deviceId,merchantVPA)=>{

    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ACTIVATE_DEVICE_TO_MERCHANT,{
            "deviceId": deviceId,
            "vpa"   : merchantVPA,
            
        })
    return response;
}

export const DeAttachFromMerchant=async(deviceId,merchantVPA)=>{
    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.REMOVE_DEVICE_FROM_MERCHANT,{
        "deviceId": deviceId,
        "vpa"   : merchantVPA,
        
    })
    
    return response;
}


export const CreateProcuredDevice=async(deviceId,organizationId,authId,lotNo)=>{

    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.CREATE_PROCURED_DEVICE_IN_INVENTORY,{
        "device_id": deviceId,
        "authenticationId"   : authId,
        "organizationId": organizationId,
        "lot_number":lotNo
    })

    return response;
}

export const RequestOnDemandDeviceStatus=async(deviceId)=>{
    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.REQUEST_ON_DEMAND_DEVICE_STATUS,{
        "device_id": deviceId,
    })

    return response;
}

export const GetOnDemandDeviceStatusData=async(deviceId)=>{
    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.GET_ON_DEMAND_DEVICE_STATUS_DATA,{
        "device_id": deviceId,
    })
    return response;
}


